// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"08442bf0","49":"859f916f","64":"ba061ae6","102":"040d02cf","205":"67918d03","266":"ba7bfa86","475":"22334874","564":"91d35beb","615":"a7961eec","625":"d45b2423","885":"73edd86c","974":"b9b602f8"}[chunkId] + ".chunk.css";
};